<template>
  <div 
        v-if="!_.isEmpty(currency) && currency.name != 'US Dollar'" 
        class="currency-wrapper"
        :style="`font-size:${fontSize}px;font-weight:${fontWeight};`"
    >

    <p v-if="label" class="currency-label">{{label}}</p>

    <p class="currency-name">{{currency.currency}}</p>

    <p 
        class="currency-symble"
        v-html="currency.symbol"
    ></p>
    
    <p class="currency">{{formatted}}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props:[  
        'price',   
        'label',
        'fontSize',
        'fontWeight'
    ],

    computed:{
        ...mapGetters({
            currency:'shippingRates/currency'
        }),

        formatted(){
            let price = parseFloat(this.price)
            let rate = parseFloat(this.currency.rate)
    
            if(!isNaN(price) && !isNaN(rate)){
                let total = (price * rate).toFixed(2)
                return total
            } else{
                return '0.00'
            }  
        }
    },
}
</script>

<style scoped>
.currency-wrapper{
    display: flex;
    color: black;
}
.currency-label{
    margin-right: 5px;
}
.currency-symble{
    margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// resources/js/components/footer/CurrencyField.vue